export default "__VITE_ASSET__2ebe5109__"